




































































import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import PicModal from '@/components/upload/picModal.vue';
import draggable from 'vuedraggable';
import EditorCustomize from '@/components/editorCustomize/index.vue';
import CouponSelect from "@/components/coupon-select/index.vue";
import CouponpackApi from '@/api/marketing/couponpack/index'
import CustomTable from '@/components/custom-table/index.vue'

class ProductImageDto {
  imageUrl: string
  id?: number
  displayOrder: number
}

@Component({
  components: {
    PicModal,
    draggable,
    EditorCustomize,
    CouponSelect,
    CustomTable
  },
})
export default class EditCouponbag extends AbpBase {
  felicaTablecolumns: any[] = [
    {
      title: '名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '卡ID',
      key: 'cardId',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  felicaFilters: any[] = [
    {
      label: '关键字：',
      type: 'input',
      props: {
        placeholder: '请输入'
      },
      key: 'Keyword'
    },
  ]
  felicaColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '图片',
      slot: 'imageUrl',
      align: 'center',
    },
    {
      title: '名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '卡号',
      key: 'cardNo',
      align: 'center',
    },
    {
      title: '有效期',
      key: 'validDate',
      align: 'center',
    },
  ]
  form: any = {
    packageName: '',
    price: null,
    quantity: 1,
    published: false,
    coupons: [],
    productImages: [],
    description: '',
    cards: []
  }
  get transcolums() {
    return [
      {
        title: "优惠券名称",
        key: "couponName"
      },
      // {
      //   title: "优惠券类型",
      //   key: "couponTypeDisplayName"
      // },
      // {
      //   title: "优惠券有效期",
      //   key: "validDate"
      // },
      {
        title: "数量",
        key: "quantity",
        width: 150,
        render: (h, params) => {
          return h("InputNumber", {
            props: {
              value: this.form.coupons[params.index] ? this.form.coupons[params.index].quantity : 0,
              min: 1
            },
            on: {
              "on-change": (event: number) => {
                this.form.coupons[params.index].quantity = event;
              }
            }
          });
        }
      },
      {
        title: "操作",
        key: "action",
        slot: "action",
        width: 150,
      }
    ]
  }

  ruleForm = {
    packageName: [{ required: true, message: '请输入券包名称', trigger: 'blur' }],
    price: [{ required: true, type: "number", message: '请输入券包价格', trigger: 'blur' }],
    quantity: [{ required: true, type: "number", message: '请输入券包数量', trigger: 'blur' }],
  }

  get selectPicNumber() {
    let num = 6
    let list = this.form.productImages
    let len = num - list.length
    // return len > 0 ? len : 0
    return 1
  }

  created() {
    let { id } = this.$route.query
    if (id) {
      this.getDetail(id)
    }
  }
  getDetail(id) {
    CouponpackApi.getDetail(id).then(res => {
      this.form = res.data
    })
  }
  editorChange(e) {
    this.form.description = e
  }
  // 选择优汇卡
  handleSelectCustomTable(e) {
    console.log('选择优汇卡', e);
    this.form.cards = e.map(item => {
      return {
        cardId: item.id,
        name: item.name
      }
    })
  }
  removeProduct(index: number) {
    this.form.cards.splice(index, 1)
  }
  // 上传图片
  headPicFn2(event) {
    let list = this.form.productImages
    let len = 6 - list.length
    len = len > event.length ? event.length : len
    for (let i = 0; i < len; i++) {
      let obj = new ProductImageDto()
      obj.imageUrl = event[i].url
      this.form.productImages.push(obj)
    }
  }
  // 删除图片
  removeImg2(index) {
    this.form.productImages.splice(index, 1)
  }
  // 删除优惠券
  removeCoupon(index) {
    this.form.coupons.splice(index, 1)
  }
  // 提交
  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        if (vm.form.productImages.length == 0) {
          this.$Notice.warning({
            title: '请上传券包图片'
          });
          return
        }
        if (!vm.form.price) {
          this.$Notice.warning({
            title: '请输入价格'
          });
          return
        }
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        if (id) {
          CouponpackApi.updateCoupon(id, vm.form).then(res => {
            vm.$Notice.success({
              title: '修改成功'
            });
            vm.$router.push({
              name: 'couponBag',
            })
          })
        } else {
          CouponpackApi.addCoupon(vm.form).then((res) => {
            vm.$Notice.success({
              title: '新增成功'
            });
            vm.$router.push({
              name: 'couponBag',
            })
          })
        }
      }
    })
  }
  couponSelectChange(list) {
    console.log(list);
    this.form.coupons = this.form.coupons.concat(
      list.map(x => {
        let item = {
          couponId: x.id,
          couponName: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          value: x.discountValue,
          quantity: 1
        };
        return item;
      })
    );
  }
}
